import { Box, Avatar, Typography } from '@material-ui/core'
import { KeyboardArrowDown } from '@material-ui/icons'
import { FunctionComponent } from 'react'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'

const DropDownArrow = styled(KeyboardArrowDown)`
  && {
    margin: 1.2em 0em 0em 0em;
  }
`
const StyledLabel = styled(Box)`
  margin: 2em 0em 0em 0em;
  overflow: hidden;
  max-width: 11ch;
  text-overflow: ellipsis;
  white-space: nowrap;
  && {
    .MuiTypography-root {
      align-self: center;
    }
  }
`
interface AdminProfileProps {
  avatar: string
  name: string
}

export const AdminProfile: FunctionComponent<AdminProfileProps> = ({ avatar, name }) => {
  const theme = useTheme()
  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box display="flex" flexDirection="row">
        <Box alignSelf="center" mr="0.5em">
          <Avatar src={avatar} />
        </Box>
        <Typography variant="body2" component="span">
          <StyledLabel fontWeight="bold" alignSelf="center" color={theme.colors.accent1}>
            {name}
          </StyledLabel>
        </Typography>
        <Box m="0em" display="flex" flexDirection="column" width="100%" mb=".50em">
          <Typography variant="caption" component="span">
            <Box color={theme.colors.primary}>
              <DropDownArrow />
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
